module.exports = __webpack_public_path__ + "static/media/menu-actions.9c727a1c.svg";